import axiosInstance from "../../services/API";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

//check with backend team about the endpoint and the data to be sent in the request body

export const postFeedback = createAsyncThunk(
    "postFeedback",
    async ({ formData }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/user_tests/feedback/`, formData);
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const FeedBackSlice = createSlice({
    name: "feedback",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // postFeedback
        builder.addCase(postFeedback.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(postFeedback.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
            state.error = null;
        });
        builder.addCase(postFeedback.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error.message;
        })
    },
});

export default FeedBackSlice.reducer;